import React, {useEffect, useState} from "react";
import "./Main.css";
import MultiRangeSlider from "multi-range-slider-react";

import FleetListCard from "../components/FleetListCard";
import FleetListItem from "../components/FleetListItem";
import axios from "axios";

const Main = () => {
	const [isChecked, setIsChecked] = useState(false);
	const [vesselData, setVesselData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [search, setSearch] = useState("");
	const [isSearchActive, setIsSearchActive] = useState(false);
	const [filters, setFilters] = useState({
		category: "",
		geared: "",
		size: "",
	});
	const [activeTab, setActiveTab] = useState("All");
	const [allVessels, setAllVessels] = useState([]); // Store all vessel titles
	const [suggestions, setSuggestions] = useState([]); // Store filtered suggestions

	const [minDwat, maxDwat] = [2000, 13000]; // Minimum and maximum DWAT values
	const [dwatMinFilter, set_minValue] = useState(2000);
	const [dwatMaxFilter, set_maxValue] = useState(13000);
	const handleInput = (e) => {
		set_minValue(e.minValue);
		set_maxValue(e.maxValue);
	};

	const [builtFilter, setBuiltFilter] = useState(0); // 0 = no filter, 1 = ascending, 2 = descending
	const [dwatFilter, setDwatFilter] = useState(0);
	const [capacityFilter, setCapacityFilter] = useState(0);

	const [highlightedIndex, setHighlightedIndex] = useState(-1); // -1 means no item is highlighted

	const handleKeyDown = (event) => {
		if (event.key === "ArrowDown") {
			// Move to the next suggestion (loop to the first if at the end)
			setHighlightedIndex((prev) => (prev < suggestions.length - 1 ? prev + 1 : 0));
		} else if (event.key === "ArrowUp") {
			// Move to the previous suggestion (loop to the last if at the start)
			setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : suggestions.length - 1));
		} else if (event.key === "Enter") {
			// Select the currently highlighted suggestion
			if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
				handleSuggestionClick(suggestions[highlightedIndex]);
			}
		}
	};

	const handleSelectChange = (e) => {
		e.preventDefault();

		const {name, value} = e.target;
		setFilters((prevFilters) => ({
			...prevFilters,
			[name]: value,
		}));
	};

	const handleCheckboxChange = (event) => {
		setIsChecked(event.target.checked);
		setBuiltFilter(0);
		setDwatFilter(0);
		setCapacityFilter(0);
	};

	const toggleFilter = (filter, setFilter) => {
		const nextState = (filter + 1) % 3; // Cycle 0 → 1 → 2 → 0
		setFilter(nextState);

		// Reset other filters to "no filtering" state
		if (setFilter !== setBuiltFilter) setBuiltFilter(0);
		if (setFilter !== setDwatFilter) setDwatFilter(0);
		if (setFilter !== setCapacityFilter) setCapacityFilter(0);
	};

	const handleSearch = async (query = search) => {
		if (query.trim() === "") return; // Prevent empty search
		try {
			setIsLoading(true);
			setIsSearchActive(true); // Indicate that search is active
			const response = await axios.get(`/wp-json/wp/v2/posts?categories=5&orderby=title&order=asc&search=${query}`);
			setVesselData(response.data);
			setSuggestions([]); // Clear suggestions after search
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	const handleSuggestionClick = (suggestion) => {
		console.log("Clicked suggestion:", suggestion);
		setSearch(suggestion); // Fill the search input with the selected suggestion
		setSuggestions([]); // Clear the suggestions to prevent secondary dropdown
		setIsSearchActive(false); // Ensure the search is no longer active
		handleSearch(suggestion); // Trigger the search with the selected suggestion
	};

	const clearSearch = () => {
		setSearch("");
		setIsSearchActive(false);
		fetchData();
	};

	const fetchData = async () => {
		try {
			setIsLoading(true);
			const response = await axios.get(`/wp-json/wp/v2/posts?categories=5&orderby=title&order=asc&per_page=100`);
			let vessels = response.data;

			// Apply category filter
			if (filters.category) {
				vessels = vessels.filter((vessel) => vessel.acf.category === filters.category);
			}

			// Apply geared filter
			if (filters.geared === "1") {
				vessels = vessels.filter((vessel) => vessel.acf.geared === "Yes");
			} else if (filters.geared === "2") {
				vessels = vessels.filter((vessel) => vessel.acf.geared === "None");
			}
			// Apply size filter
			if (filters.size) {
				vessels = vessels.filter((vessel) => vessel.acf.size === filters.size);
			}

			// Apply DWT filter
			if (activeTab !== "All" && activeTab) {
				vessels = vessels.filter((vessel) => vessel.acf.dwt === activeTab);
			}

			// Apply DWAT range filter
			vessels = vessels.filter((vessel) => {
				const dwat = parseInt(vessel.acf.dwat);
				return dwat >= dwatMinFilter && dwat <= dwatMaxFilter;
			});

			if (builtFilter === 1) {
				vessels = vessels.sort((a, b) => a.acf.built - b.acf.built); // Ascending
			} else if (builtFilter === 2) {
				vessels = vessels.sort((a, b) => b.acf.built - a.acf.built); // Descending
			}

			// if (dwatFilter === 1) {
			//   vessels = vessels.sort((a, b) => a.acf.dwat - b.acf.dwat); // Ascending
			// } else if (dwatFilter === 2) {
			//   vessels = vessels.sort((a, b) => b.acf.dwat - a.acf.dwat); // Descending
			// }

			// New Filter
			if (dwatFilter === 1) {
				vessels = [...vessels].sort((a, b) => Number(a.acf.dwat) - Number(b.acf.dwat));
			} else if (dwatFilter === 2) {
				vessels = [...vessels].sort((a, b) => Number(b.acf.dwat) - Number(a.acf.dwat));
			}

			if (capacityFilter === 1) {
				vessels = vessels.sort((a, b) => a.acf.capacity - b.acf.capacity); // Ascending
			} else if (capacityFilter === 2) {
				vessels = vessels.sort((a, b) => b.acf.capacity - a.acf.capacity); // Descending
			}

			setVesselData(vessels);

			// Store all titles for autofill suggestions
			setAllVessels(vessels.map((vessel) => vessel.title.rendered));
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [filters, activeTab, dwatMaxFilter, dwatMinFilter, builtFilter, dwatFilter, capacityFilter]);

	useEffect(() => {
		if (search.trim()) {
			const filteredSuggestions = allVessels.filter((title) => title.toLowerCase().includes(search.toLowerCase()));
			setSuggestions(filteredSuggestions);
		} else {
			setSuggestions([]);
		}
	}, [search, allVessels]);

	// const sendHeightToParent = () => {
	//   const iframe = window.frameElement; // Get reference to the iframe element
	//   const contentDocument = iframe.contentDocument; // Access the content document

	//   if (contentDocument) {
	//     // Use the content document's body or another element to calculate height
	//     const contentHeight = contentDocument.body.scrollHeight;

	//     // Send the height to the parent
	//     window.parent.postMessage(
	//       { type: "resizeIframe", height: contentHeight },
	//       "*"
	//     );
	//   }
	// };

	// New Function
	const sendHeightToParent = () => {
		const iframe = window.frameElement;

		// If not inside an iframe, stop here
		if (!iframe) return;

		const contentHeight = document.body.scrollHeight;

		window.parent.postMessage({type: "resizeIframe", height: contentHeight}, "*");
	};

	useEffect(() => {
		sendHeightToParent();
	}, [search, filters, dwatMaxFilter, dwatMinFilter, builtFilter, dwatFilter, capacityFilter, isChecked, allVessels]);

	useEffect(() => {
		sendHeightToParent();
	}, []);

	const gearedYesCount = vesselData?.filter((vessel) => vessel.acf.geared === "Yes").length;
	const gearedNoneCount = vesselData?.filter((vessel) => vessel.acf.geared === "None").length;
	const allVesselsCount = vesselData?.length;

	return (
		<>
			<div className="fleet-list-header">
				<h1 className="header-page-title">
					DISCOVER OUR <br />
					VERSATILE FLEET
				</h1>

				<div className="header-search">
					<div className="search-bar">
						<input
							autoComplete="off"
							type="text"
							name="vessel-search"
							id="vessel-search"
							placeholder="Search a vessel"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							onKeyDown={handleKeyDown}
						/>
						<i
							onClick={() => handleSearch()}
							className="fa-solid fa-magnifying-glass search-icon"
							style={{cursor: "pointer"}}
						></i>
					</div>

					{/* Autofill suggestions */}
					{suggestions.length > 0 && (
						<div className="suggestions-dropdown">
							{suggestions.map((suggestion, index) => (
								<div
									key={index}
									className={`suggestion-item ${index === highlightedIndex ? "highlighted" : ""}`}
									onClick={() => handleSuggestionClick(suggestion)}
								>
									{suggestion}
								</div>
							))}
						</div>
					)}

					{isSearchActive && (
						<button
							onClick={clearSearch}
							className="clear-search-btn"
						>
							Clear Search
						</button>
					)}
					<div className="select-container">
						<div className="radio-select">
							<div className="radio-select-header">Geared</div>
							<div className="radio-btns">
								<label>
									<input
										type="radio"
										name="geared"
										value=""
										checked={filters.geared === ""}
										onChange={handleSelectChange}
									/>
									<span>All {filters.geared === "" ? `(${allVesselsCount})` : null}</span>
								</label>
								<label>
									<input
										type="radio"
										name="geared"
										value="1"
										checked={filters.geared === "1"}
										onChange={handleSelectChange}
									/>
									<span>Yes {filters.geared === "" ? `(${gearedYesCount})` : null}</span>
								</label>
								<label>
									<input
										type="radio"
										name="geared"
										value="2"
										checked={filters.geared === "2"}
										onChange={handleSelectChange}
									/>
									<span>No {filters.geared === "" ? `(${gearedNoneCount})` : null}</span>
								</label>
							</div>
						</div>
						{/* <div className="custom-select">
              <select
                name="size"
                value={filters.size}
                onChange={handleSelectChange}
              >
                <option value="">Size</option>
                <option value="Size Test 1">Size Test 1</option>
                <option value="Size Test 2">Size Test 2</option>
                <option value="Size Test 3">Size Test 3</option>
              </select>
            </div> */}
					</div>

					<div className="range-slider">
						<strong>Size (DWAT)</strong>
						<MultiRangeSlider
							min={minDwat}
							max={maxDwat}
							minValue={dwatMinFilter}
							maxValue={dwatMaxFilter}
							onInput={(e) => {
								handleInput(e);
							}}
						/>
					</div>
				</div>
			</div>

			<div className="fleet-list-container">
				{/* <div className="checkbox-wrapper-6">
					<span className={!isChecked && "checked"}>CARDS</span>
					<input
						className="tgl tgl-light"
						id="cb1-6"
						type="checkbox"
						checked={isChecked}
						onChange={handleCheckboxChange}
					/>
					<label
						className="tgl-btn"
						htmlFor="cb1-6"
					/>
					<span className={isChecked && "checked"}>LIST</span>
				</div> */}

				{/* New Function */}
				<div className="checkbox-wrapper-6">
					<span className={!isChecked && "checked"}>CARDS</span>
					<input
						className="tgl tgl-light"
						id="cb1-6"
						type="checkbox"
						checked={isChecked}
						onChange={handleCheckboxChange}
					/>
					<label
						className="tgl-btn"
						htmlFor="cb1-6"
					/>
					<span className={isChecked && "checked"}>LIST</span>

					{/* DWAT Sort button only shows in Grid view */}
					{!isChecked && (
						<div
							className={`grid-dwat-sort sort-${dwatFilter}`}
							onClick={() => toggleFilter(dwatFilter, setDwatFilter)}
						>
							Sort by DWAT
							{dwatFilter === 0 && <i className="fa-solid fa-sort"></i>}
							{dwatFilter === 1 && <i className="fa-solid fa-chevron-up"></i>}
							{dwatFilter === 2 && <i className="fa-solid fa-chevron-down"></i>}
						</div>
					)}
				</div>

				{isLoading ? (
					<div className="loading-div">
						<h3>Loading vessels...</h3>
					</div>
				) : // Display Cards or List depending on checkbox switch
				!isChecked ? (
					// <>
					// 	{/* DWAT Sort Control for Grid */}
					// 	<div className="grid-sort-controls">
					// 		<div
					// 			className={`grid-dwat-sort sort-${dwatFilter}`}
					// 			onClick={() => toggleFilter(dwatFilter, setDwatFilter)}
					// 		>
					// 			Sort by DWAT
					// 			{dwatFilter === 0 && <i className="fa-solid fa-sort"></i>}
					// 			{dwatFilter === 1 && <i className="fa-solid fa-chevron-up"></i>}
					// 			{dwatFilter === 2 && <i className="fa-solid fa-chevron-down"></i>}
					// 		</div>
					// 	</div>
						<div
							id="fleet-list-cards"
							className="fleet-list-row"
						>
							{vesselData.length > 0 ? (
								vesselData.map((vessel, index) => (
									<FleetListCard
										key={index}
										vessel={vessel}
									/>
								))
							) : (
								<div className="no-vessels-found">
									<h3>No vessels found</h3>
									<p>
										<i
											onClick={() => window.location.reload()}
											className="fa-solid fa-arrows-rotate"
										></i>
										Please refresh or clear your filters.
									</p>
								</div>
							)}
						</div>
					// </>
				) : (
					<div id="fleet-list-list">
						<div className="fleet-list-item top-filters-list">
							<div className="list-item-inner">
								<div className="item-col button-invisible"> A</div>
								<div
									className={`item-col built-filter-${builtFilter}`}
									onClick={() => toggleFilter(builtFilter, setBuiltFilter)}
								>
									{builtFilter === 1 && <i className="fa-solid fa-chevron-up"></i>}
									{builtFilter === 2 && <i className="fa-solid fa-chevron-down"></i>}
									{builtFilter === 0 && <i className="fa-solid fa-sort"></i>}
								</div>
								<div
									className={`item-col dwat-filter-${dwatFilter}`}
									onClick={() => toggleFilter(dwatFilter, setDwatFilter)}
								>
									{dwatFilter === 1 && <i className="fa-solid fa-chevron-up"></i>}
									{dwatFilter === 2 && <i className="fa-solid fa-chevron-down"></i>}
									{dwatFilter === 0 && <i className="fa-solid fa-sort"></i>}
								</div>
								<div
									className={`item-col capacity-filter-${capacityFilter}`}
									onClick={() => toggleFilter(capacityFilter, setCapacityFilter)}
								>
									{capacityFilter === 1 && <i className="fa-solid fa-chevron-up"></i>}
									{capacityFilter === 2 && <i className="fa-solid fa-chevron-down"></i>}
									{capacityFilter === 0 && <i className="fa-solid fa-sort"></i>}
								</div>
								<div className="item-col button-invisible"> A</div>
								<div className="item-col">
									<a
										className="more-info-btn button-invisible"
										href="#"
									>
										More info
									</a>
									<a
										className="downloads-specs-btn button-invisible"
										target="_blank"
										rel="noreferrer"
										href="#"
									>
										Download specs <i className="fa-solid fa-cloud-arrow-down"></i>
									</a>
								</div>
							</div>
						</div>
						{vesselData.length > 0 ? (
							vesselData.map((vessel, index) => (
								<FleetListItem
									key={index}
									vessel={vessel}
								/>
							))
						) : (
							<div className="no-vessels-found">
								<h3>No Vessels found</h3>
								<p>
									<i
										onClick={() => window.location.reload()}
										className="fa-solid fa-arrows-rotate"
									></i>
									Please refresh or clear your filters.
								</p>
							</div>
						)}
					</div>
				)}
			</div>
		</>
	);
};

export default Main;
